import { useCallback, useMemo } from 'react'

import { getContract, prepareContractCall } from 'thirdweb'
import { useSendTransaction } from 'thirdweb/react'

import Client from '../client'
import { CHAIN_IDS_TO_MESSAGE_TRANSMITTER_ADDRESSES } from '../constants/address'
import { CHAIN_IDS_TO_CHAINS } from '../constants/chain'

import type { SupportedChainId } from '../constants/chain'
import type { Hex } from 'thirdweb'

/**
 * Returns a list of states/actions available from the Message Transmitter contract.
 * @param chainId - The chain ID that given contract address is on.
 */
export const useMessageTransmitter = (chainId: SupportedChainId) => {
  const client = Client.instance
  const chain = CHAIN_IDS_TO_CHAINS[chainId]
  const contractAddress = CHAIN_IDS_TO_MESSAGE_TRANSMITTER_ADDRESSES[chainId]

  const contract = useMemo(
    () =>
      getContract({
        client,
        chain,
        address: contractAddress,
      }),
    [chain, client, contractAddress],
  )

  const {
    mutate: sendTransaction,
    data,
    error,
    isPending,
    isSuccess,
  } = useSendTransaction({ payModal: false })

  const receiveMessage = useCallback(
    (message: string, attestation: string) => {
      const transaction = prepareContractCall({
        contract,
        method: 'function receiveMessage(bytes message, bytes attestation)',
        params: [message as Hex, attestation as Hex],
      })
      sendTransaction(transaction)
    },
    [contract, sendTransaction],
  )

  return {
    receiveMessage,
    data,
    error,
    isPending,
    isSuccess,
  }
}
